export default "__VITE_ASSET__zF8EvRca__"